import { fetchApi } from '@/config/axiosSetting';
import {
  GetChassisPdfQueryFunctionPropsType,
  GetChassisPdfQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getChassisPdf/getChassisPdfQuery.type';

export const getChassisPdfFunction = (
  params: GetChassisPdfQueryFunctionPropsType,
): Promise<GetChassisPdfQueryResponseType> => {
  return fetchApi.get('defaults/static_files/', {
    params: {
      name: 'vehicle_chassis_site_guide_pdf',
      vehicle_type: params.vehicle_type,
    },
  });
};
